import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const WaitlistScreen = lazy(() => import("@/pages/WaitlistScreen"));

export const Route = createFileRoute("/waitlist")({
  component: WaitlistScreen,
});
